import { z } from 'zod';

import type { PlatformAlias } from './platform';

export const MychipsIntegrationMode = z.enum(['IFRAME', 'SDK']);
export type MychipsIntegrationMode = z.infer<typeof MychipsIntegrationMode>;

export const SUPPORTED_MYCHIPS_PLATFORM_ALIASES = [
	'WEB',
	'APP_IOS',
	'APP_ANDROID',
] as const satisfies readonly PlatformAlias[];
export type SupportedMychipsPlatformAlias = typeof SUPPORTED_MYCHIPS_PLATFORM_ALIASES[number];

export const MYCHIPS_INTEGRATION_MODE_BY_PLATFORM_ALIAS = {
	WEB: 'IFRAME',
	APP_IOS: 'SDK',
	APP_ANDROID: 'SDK',
} as const satisfies Record<SupportedMychipsPlatformAlias, MychipsIntegrationMode>;
